export default __webpack_public_path__ + "static/media/landing_page_regulatory_compliance.7b4fab67.gif";